import { RadiusOptions, SearchModel } from '@smg-real-estate/hg-search-libs';

export const DEFAULT_PRICE_INCREASE = 500;

export function relaxRadiusCriteria(
  searchModel: SearchModel,
  radiusIncrease: RadiusOptions,
): SearchModel {
  const originalRadius = searchModel.radius ?? 0;

  return searchModel.withRadius(originalRadius + radiusIncrease);
}

export function relaxPriceCriteria(searchModel: SearchModel, priceIncrease: number): SearchModel {
  const originalPrice = searchModel.priceRange?.to ?? 0;

  return searchModel.withPriceTo(originalPrice + priceIncrease);
}
